const concatArray = (arrays: Uint8Array[]) => {
  const totalLength = arrays.reduce((acc, value) => acc + value.length, 0);
  const mergedArray = new Uint8Array(totalLength);

  let length = 0;
  arrays.forEach((array) => {
    mergedArray.set(array, length);
    length += array.length;
  });

  return mergedArray;
};

export const encryptPIN = async (
  pin: string,
  publicKey: string,
  oneTimeToken: string
): Promise<string> => {
  const { default: _sodium } = await import('libsodium-wrappers');
  await _sodium.ready;
  const {
    crypto_box_seal,
    from_string,
    from_hex,
    to_hex,
    crypto_aead_xchacha20poly1305_ietf_keygen,
    randombytes_buf,
    crypto_aead_xchacha20poly1305_ietf_encrypt,
    crypto_aead_xchacha20poly1305_ietf_NPUBBYTES,
  } = _sodium;

  const pub = from_hex(publicKey);

  //generate random one-time key & nonce for AEAD
  let encKey = crypto_aead_xchacha20poly1305_ietf_keygen();
  let nonce = randombytes_buf(crypto_aead_xchacha20poly1305_ietf_NPUBBYTES);

  //encrypt PIN with key, nonce and use One Time Token as AD
  const encryptedPin = crypto_aead_xchacha20poly1305_ietf_encrypt(
    from_string(pin),
    from_string(oneTimeToken),
    null,
    nonce,
    encKey
  );

  const message = concatArray([encKey, nonce]);
  // Encrypt key & nonce using provided public key
  const encryptedKeyNonce = crypto_box_seal(message, pub);

  //put everything together. Key&nonce first, because they are fixed size
  const res = concatArray([encryptedKeyNonce, encryptedPin]);

  return to_hex(res);
};
